import { useCallback, useState } from "react";

/**
 * Hook che gestisce la selezione multipla di alunni per il deep-link verso
 * Comunicazioni. Mantiene un `Set<number>` dei codici alunno selezionati e
 * fornisce helper per toggle/select-all/clear.
 *
 * Uso:
 *   const { selected, toggle, selectAll, clear, isSelected, size } = useAlunniSelection();
 *   ...
 *   <input type="checkbox" checked={isSelected(it.Cod)} onChange={() => toggle(it.Cod)} />
 *   <AlunniSendBar selected={selected} onClear={clear} label="..." anno={...} />
 */
export default function useAlunniSelection() {
  const [selected, setSelected] = useState(() => new Set());
  const isSelected = useCallback((cod) => selected.has(Number(cod)), [selected]);
  const toggle = useCallback((cod) => {
    setSelected(prev => {
      const n = new Set(prev);
      const k = Number(cod);
      if (n.has(k)) n.delete(k); else n.add(k);
      return n;
    });
  }, []);
  const selectAll = useCallback((cods) => {
    setSelected(prev => {
      const n = new Set(prev);
      for (const c of (cods || [])) if (Number.isFinite(Number(c))) n.add(Number(c));
      return n;
    });
  }, []);
  const deselectAll = useCallback((cods) => {
    setSelected(prev => {
      const n = new Set(prev);
      for (const c of (cods || [])) n.delete(Number(c));
      return n;
    });
  }, []);
  const clear = useCallback(() => setSelected(new Set()), []);
  return { selected, toggle, selectAll, deselectAll, clear, isSelected, size: selected.size };
}
